// Truck stock's words (BL-203), shared by Domain/Stock's parts: a quantity in its unit, a change in it,
// and when a level is below its minimum or has none. stock.levels gives quantities as strings ("5.000").

/** "5.000" → "5", "2.500" → "2.5", "63" ft → "63 ft". */
export function qtyWords(value: string | number, unit = 'each'): string {
  const n = typeof value === 'string' ? Number(value) : value;
  const text = Number.isInteger(n) ? String(n) : String(Number(n.toFixed(3)));
  return unit === 'each' ? text : `${text} ${unit}`;
}

/** A change, signed: "+1", "−8", "−3 ft" (a minus sign, not a hyphen). */
export function offWords(by: number, unit = 'each'): string {
  return `${by < 0 ? '−' : '+'}${qtyWords(Math.abs(by), unit)}`;
}

/** Below its minimum: it has one, and less than it is on hand. */
export const isBelowMin = (l: { onHand: string; min: string }) =>
  Number(l.min) > 0 && Number(l.onHand) < Number(l.min);

/** No minimum and no maximum: the refill never brings it. */
export const hasNoMin = (l: { min: string; max: string }) => Number(l.min) === 0 && Number(l.max) === 0;

/** A quantity as typed: a number, 0 or more, with at most three decimals. */
export function readQty(typed: string): number | null {
  const t = typed.trim();
  return /^\d{1,9}(\.\d{1,3})?$/.test(t) ? Number(t) : null;
}
